import React from 'react';
import './ITSoftware.css';

function AgroAqua() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/agro_aqua_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Agriculture & Aquaculture</h1>
          <p>Empowering agro-based businesses with tax, export, subsidy, and sustainability advisory</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Driving Growth Across Green & Blue Economies</h2>
          <p>We support agri-entrepreneurs, cooperatives, and aquaculture units in navigating subsidies, FPO compliance, and farm accounting.</p>
          <p>Our services include GST on agri-inputs, warehouse receipts, fishery licensing, and export-oriented tax planning.</p>
          <p>We help ag-tech and aqua-tech startups with business modeling, entity formation, and investor documentation.</p>
          <p>Whether it’s organic farming or inland shrimp farming, we align your operations with statutory and commercial efficiency.</p>
        </div>
        <div className="content-right">
          <img src="/images/agro_aqua.jpg" alt="Agriculture & Aquaculture" />
        </div>
      </section>
    </div>
  );
}

export default AgroAqua;
